module.exports = __webpack_public_path__ + "dist/img/Online-Service.5a80aec2.jpg";